export default async function fetchApi(url, getAccessTokenSilently = null,method="get",data = null) {
    try {
        const token = await getAccessTokenSilently({
            authorizationParams: {
                audience: 'http://localhost:3000',
            }
        });
        //const response = await fetch('https://import-api.berger-shop.de/' + url, {
        const response = await fetch('https://import-api-staging-0-48-dev1.berger-shop.de/' + url, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                ...(data !== null && { "Content-Type": "application/json" })
            },
            ...(data !== null && { body: JSON.stringify(data)})
        });
        return await response.json()
    } catch (e) {
        console.error(e);
        return false;
    }
}